import { RankedTester, and, rankWith, optionIs, schemaTypeIs } from "@jsonforms/core";

export const CourseSelectMultipleTester: RankedTester = rankWith(
  3,
  and(schemaTypeIs("array"), optionIs("CourseSelect", true))
);

export default CourseSelectMultipleTester;
